module.exports = __webpack_public_path__ + "img/135-efc3a0.png";